import styled from 'styled-components';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const StyledReadMore = styled.span`
  display: flex;
  gap: 4px;
  align-items: center;
  .chevron-right-icon {
    margin-top: 5px;
    color: ${themeColor('blue4')};
  }
  cursor: pointer;
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(1)};
  }
`;

export const TestimonialContainer = styled(Box)`
  width: 100%;
  display: flex;
  min-height: 800px;
  flex-direction: row;
  ${themeMediaQuery('below_sm')} {
    min-height: 962px;
    height: auto;
    flex-direction: column-reverse;
  }
`;

export const DetailWrapper = styled.div`
  width: 50%;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const TestimonialDetails = styled(Columns)`
  height: 100%;
  ${themeMediaQuery('below_sm')} {
    height: auto;
  }
  ${themeMediaQuery('tablet')} {
    min-width: 90%;
  }
`;

export const TestimonialContent = styled(Columns.Column)<{ isExpanded?: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: ${themeSpace(9)};
  ${themeMediaQuery('below_sm')} {
    padding: ${themeSpace(0)};
    padding-top: ${themeSpace(4)};
    padding-bottom: ${themeSpace(4)};
    gap: ${themeSpace(5)};
    height: auto;
    min-height: 706px;
  }
  ${themeMediaQuery('tablet')} {
    padding-top: ${themeSpace(6)};
    padding-bottom: ${themeSpace(6)};
    gap: ${themeSpace(5)};
    height: auto;
    min-height: 710px;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  padding: 0 ${themeSpace(5)};
  ${themeMediaQuery('below_sm')} {
    padding-right: ${themeSpace(4)};
  }
  blockquote {
    //TODO: Change the font size and line height to follow joykit standards
    //Keeping it differnt for now as the first iteration since no design is available
    margin: 0;
    font-size: 22px;
    line-height: 36px;
    letter-spacing: 1px;
    ${themeMediaQuery('below_sm')} {
      font-size: 18px;
      line-height: 28px;
    }
    ${themeMediaQuery('tablet')} {
      font-size: 25px;
      line-height: 36px;
    }
  }
`;

export const TestimonialAsset = styled(Box)<{ src: string }>`
  width: 50%;
  background-image: url(${({ src }) => cloudAssetUrl(src, { optimization: 'aggressive' })});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 80vw;
  }
  ${themeMediaQuery('tablet')} {
    height: 70vw;
  }
`;

export const StyledQuotesContainer = styled.div<{ isExpanded: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-self: baseline;
  padding: 0 ${themeSpace(5)};
  ${themeMediaQuery('sm')} {
    padding-top: ${themeSpace(5)};
  }
  //TODO: Change the font size and line height to follow joykit standards
  //Keeping it differnt for now as the first iteration  since no design available
  h3 {
    font-size: 17px;

    ${themeMediaQuery('below_sm')} {
      font-size: 14px;
    }
    ${themeMediaQuery('tablet')} {
      font-size: 16px;
    }
  }
`;
